/** Generate Text node width — canonical STANDARD preset (same collapsed/expanded). */

import { generationNodeCardWidth } from './generationNodeWidthPresets'

export const GENERATE_TEXT_CARD_WIDTH_PX = generationNodeCardWidth('generate_text')

/** @deprecated Legacy forensic reference only. */
export const GENERATE_TEXT_EXPANDED_WIDTH_LEGACY_CSS = 'clamp(720px, 52vw, 840px)'

export function resolveGenerateTextCardWidthCss(_isExpanded: boolean): number {
  return GENERATE_TEXT_CARD_WIDTH_PX
}

export function resolveGenerateTextInlineMinWidthPx(_isExpanded: boolean): number | undefined {
  return undefined
}
